<ion-content>
  <div class="upgrade-feature-banner" *ngIf="!featureEnabled">
    <div
      class="constrained-content flex-space-between"
      style="align-items: center"
    >
      Upgrade to get real-time webhook updates
      <ion-button
        fill="outline"
        color="light"
        class="btn-small"
        [routerLink]="'/upgrade'"
      >
        <ion-icon name="arrow-up-circle" class="padded-icon"></ion-icon>
        Upgrade account
      </ion-button>
    </div>
  </div>

  <ion-grid class="constrained-content">
    <ion-row *ngIf="webhookConfig">
      <ion-col size-md="5" size="12" class="settings-title-section">
        <h1><ion-icon name="custom-webhooks"></ion-icon>Webhooks</h1>
        <p class="subtitle">Receive real-time events via webhooks</p>
        <p class="subtitle" style="opacity: 1">
          <a (click)="showWebhookHelpdesk()">
            Learn more about webhook events
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </a>
        </p>
        <div style="opacity: 1; margin: 30px 0 0 36px">
          <h5>Webhook signing secret</h5>
          <div class="flexed">
            <ion-input
              [disabled]="true"
              [(ngModel)]="webhookConfig.secret"
              class="input-field signing-secret"
              [type]="signingSecretShown ? 'text' : 'password'"
              style="margin: 0"
            ></ion-input>
            <ion-button fill="clear" (click)="toggleSigningSecret()">{{
              signingSecretShown ? "Hide" : "Show"
            }}</ion-button>
          </div>
        </div>
      </ion-col>

      <ion-col size-md="7" size="12">
        <ion-card
          *ngFor="
            let webhookSubscription of webhookSubscriptions;
            let i = index
          "
          class="outline-card"
          style="margin: 10px 10px 30px 10px"
        >
          <ion-card-content class="border-top">
            <div class="subtitle">Endpoint URL</div>
            <ion-input
              placeholder="https://yourserver.com/api/endpoint"
              [(ngModel)]="webhookSubscription.url"
              class="input-field"
              style="margin: 0"
            ></ion-input>

            <div class="subtitle">Enabled</div>
            <label class="switch" slot="end">
              <input
                type="checkbox"
                [(ngModel)]="webhookSubscription.enabled"
              />
              <span class="slider"></span>
            </label>
          </ion-card-content>

          <div class="border-top">
            <ion-button
              color="success"
              (click)="save(i)"
              class="save-button"
              [disabled]="!featureEnabled"
            >
              Save
            </ion-button>
            <ion-button
              color="danger"
              fill="clear"
              (click)="delete(i)"
              *ngIf="webhookSubscriptions.length"
              >Delete</ion-button
            >
          </div>
        </ion-card>

        <ion-button
          fill="clear"
          size="block"
          class="btn-large"
          style="margin: 32px 12px"
          (click)="addWebhookSubscription()"
          *ngIf="
            webhookSubscriptions.length &&
            webhookSubscriptions[webhookSubscriptions.length - 1].id
          "
        >
          <ion-icon name="add-outline" class="padded-icon"></ion-icon>Add
          another webhook subscription
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
